import React, { useState } from "react";
import { RiMenuAddFill, RiDeleteBin5Line } from "react-icons/ri";
import { FiPlusSquare, FiMinusSquare } from "react-icons/fi";
import { AiOutlineDelete } from "react-icons/ai";

export const ServiceCatagories = () => {
  const [showLayouts, setShowLayouts] = useState(Array(8).fill(false));
  const [expandedRows, setExpandedRows] = useState({});
  const [topAddClicked, setTopAddClicked] = useState({});

  const data = [
    "Agriculture & Food",
    "Agriculture & Food",
    "Agriculture & Food",
  ];

  const toggleLayout = (index) => {
    const updated = [...showLayouts];
    updated[index] = !updated[index];
    setShowLayouts(updated);
  };

  const toggleSearch = (outerIdx, innerIdx) => {
    setExpandedRows((prev) => {
      const outer = prev[outerIdx] || {};
      return {
        ...prev,
        [outerIdx]: {
          ...outer,
          [innerIdx]: !outer[innerIdx],
        },
      };
    });
  };

  const handleTopAddClick = (outerIdx) => {
    setTopAddClicked((prev) => ({
      ...prev,
      [outerIdx]: !prev[outerIdx],
    }));

    setShowLayouts((prev) => {
      const updated = [...prev];
      updated[outerIdx] = true;
      return updated;
    });
  };

  return (
    <div className="h-96 overflow-y-scroll space-y-4">
      {Array.from({ length: 8 }).map((_, outerIdx) => (
        <div key={outerIdx} className="rounded-md">
          {/* Top bar */}
          <div className="flex gap-3 border-b p-2 items-center">
            <RiMenuAddFill
              className="text-xl text-gray-600 cursor-pointer"
              onClick={() => handleTopAddClick(outerIdx)}
            />
            <AiOutlineDelete className="text-xl text-gray-600" />
            {showLayouts[outerIdx] ? (
              <FiMinusSquare
                className="text-xl text-blue-500 cursor-pointer"
                onClick={() => toggleLayout(outerIdx)}
              />
            ) : (
              <FiPlusSquare
                className="text-xl text-blue-500 cursor-pointer"
                onClick={() => toggleLayout(outerIdx)}
              />
            )}
            <input type="checkbox" className="w-5 h-5 accent-blue-500" />
            <span className="text-gray-700 font-medium">
              Agriculture & Food
            </span>
          </div>

          {/* Inner layout */}
          {showLayouts[outerIdx] && (
            <div className="p-3 rounded-md transition-all duration-300">
              {/* Top Add Row */}
              {topAddClicked[outerIdx] && (
                <div className="mb-4 ps-10">
                  <div className="flex border rounded-full max-w-md w-full">
                    <div className="bg-gray-400 rounded-s-full px-3 flex items-center">
                      <span>00</span>
                    </div>
                    <input
                      type="text"
                      placeholder="enter categories name"
                      className="flex-1 text-sm px-3 py-1 focus:outline-none"
                    />
                    <button className="bg-gray-400 text-white px-4 rounded-e-full text-sm hover:bg-gray-500">
                      Add
                    </button>
                  </div>
                </div>
              )}

              {/* Child Items */}
              {data.map((code, innerIdx) => (
                <div key={innerIdx}>
                  <div className="flex gap-3 items-center ps-10 py-2">
                    {innerIdx < 2 ? (
                      <RiMenuAddFill
                        className="text-xl text-gray-600 cursor-pointer"
                        onClick={() => toggleSearch(outerIdx, innerIdx)}
                      />
                    ) : (
                      <div className="w-[24px]" />
                    )}
                    <AiOutlineDelete className="text-xl text-gray-600" />
                    <FiPlusSquare className="text-xl text-gray-600" />
                    <input
                      type="checkbox"
                      className="w-5 h-5 accent-blue-500"
                    />
                    <span className="text-gray-700">{code}</span>
                  </div>

                  {/* Row-wise input */}
                  {expandedRows[outerIdx]?.[innerIdx] && (
                    <div className="ps-16 mb-3">
                      <div className="flex border rounded-full max-w-md w-full">
                        <div className="bg-gray-400 rounded-s-full px-3 flex items-center">
                          <span>01</span>
                        </div>
                        <input
                          type="text"
                          placeholder="enter categories name"
                          className="flex-1 text-sm px-3 py-1 focus:outline-none"
                        />
                        <button className="bg-gray-400 text-white px-4 rounded-e-full text-sm hover:bg-gray-500">
                          Add
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
